import type { RadioProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Radio(props: RadioProps, ref: React.Ref<HTMLDivElement>) {
  const { checked, onChange, className, style, disabled, theme = 'dark' } = props;

  const handleClick = () => {
    if (disabled) {
      return;
    }
    onChange?.(!checked);
  };

  return (
    <div
      ref={ref}
      className={cn('wg-radio', {
        'wg-radio--checked': checked,
        'wg-radio--disabled': disabled,
        'wg-radio--light': theme === 'light',
        'wg-radio--dark': theme === 'dark',
      }, className)}
      style={style}
      onClick={handleClick}
    >
      <svg fill="none" viewBox="0 0 15 14" width="10" height="9.3">
        <path d="M2 8.36364L6.23077 12L13 2"></path>
      </svg>
    </div>
  );
}

const RadioComponent = forwardRef<HTMLDivElement, RadioProps>(Radio);
RadioComponent.displayName = 'Radio';

export default RadioComponent;

export type { RadioProps };
